import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { throttle } from 'lodash';
import { Popover } from '@fiverr-private/fit';
import { loadDrawerData } from '../../store/actions';
import * as apps from '../../enums/apps';
import TabsWrapper from '../TabsWrapper';
import {
    TYPES,
    includesInboxDrawer,
    includesNotificationsDrawer,
    isMessagesType,
} from '../../NotificationsDrawer/types';
import { POPOVER_NOTIFICATIONS_DRAWER_CSS_CLASS } from '../../../shared/constants';
import { showInboxByDefault } from './selectors';
import { initInbox, initNotifications } from './init';
import { getButtonComponent } from './getButtonComponent';

import styles from './style.module.scss';

class NotificationsPopover extends Component {
    constructor(props) {
        super(props);
        this.handleMouseEnter = throttle(this.handleMouseEnter.bind(this), 30000);
    }

    componentDidMount() {
        const { drawerType } = this.props;

        if (includesInboxDrawer(drawerType)) {
            initInbox();
        }

        if (includesNotificationsDrawer(drawerType)) {
            initNotifications();
        }
    }

    handleMouseEnter() {
        this.loadAppItemsByDrawerType();
    }

    loadAppItemsByDrawerType() {
        const { drawerType, loadAppItems } = this.props;

        if (includesInboxDrawer(drawerType)) {
            loadAppItems(apps.APP_NAME_INBOX);
        }

        if (includesNotificationsDrawer(drawerType)) {
            loadAppItems(apps.APP_NAME_NOTIFICATIONS);
        }
    }

    render() {
        const {
            drawerType,
            username,
            defaultOpenInbox,
            count,
            notificationSoundEnabled,
            popoverClassName,
            popoverBoxClassName,
            unreadDotClassName,
            trigger,
            onTriggerClick,
        } = this.props;

        let isMessagesTypeValue = defaultOpenInbox;
        let tabsClassName;
        let position = Popover.POSITIONS.CENTER;
        const isNotDefaultType = drawerType && drawerType !== TYPES.BOTH;

        if (isNotDefaultType) {
            isMessagesTypeValue = isMessagesType(drawerType);
            tabsClassName = classNames(isMessagesTypeValue ? 'tabs-messages' : 'tabs-notifications');
            position = Popover.POSITIONS.BOTTOM_RIGHT;
        }

        const target = getButtonComponent({
            drawerType,
            handleMouseEnter: this.handleMouseEnter,
            count,
            unreadDotClassName,
            trigger,
            onTriggerClick,
        });

        return (
            <Popover
                className={classNames(styles.popover, POPOVER_NOTIFICATIONS_DRAWER_CSS_CLASS, popoverClassName)}
                contentClassName={POPOVER_NOTIFICATIONS_DRAWER_CSS_CLASS}
                boxClassName={popoverBoxClassName}
                position={position}
                content={
                    <TabsWrapper
                        className={tabsClassName}
                        drawerType={drawerType}
                        notificationSoundEnabled={notificationSoundEnabled}
                        username={username}
                        defaultOpenInbox={isMessagesTypeValue}
                    />
                }
            >
                {target}
            </Popover>
        );
    }
}

NotificationsPopover.propTypes = {
    loadAppItems: propTypes.func,
    defaultOpenInbox: propTypes.bool,
    username: propTypes.string,
    popoverClassName: propTypes.string,
    popoverBoxClassName: propTypes.string,
    unreadDotClassName: propTypes.string,
    notificationSoundEnabled: propTypes.bool,
    count: propTypes.shape({
        [apps.APP_NAME_INBOX]: propTypes.number,
        [apps.APP_NAME_NOTIFICATIONS]: propTypes.number,
    }),
    drawerType: propTypes.oneOf(Object.values(TYPES)),
    trigger: propTypes.node,
    onTriggerClick: propTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    loadAppItems: (app) => dispatch(loadDrawerData(app)),
});

export default connect(
    ({ count }) => ({
        defaultOpenInbox: showInboxByDefault(count),
        count,
    }),
    mapDispatchToProps
)(NotificationsPopover);
